export default __webpack_public_path__ + "static/media/amount.4563677b.svg";